import { createReducer } from '@reduxjs/toolkit';
import {
  getNotificationList,createNotification,updateNotification, setFcmToken, setGlobalNotificationCount, markAllRead, clearNotificationList
} from '../actions/notification.actions';
const isClient = typeof window !== 'undefined';

const initialState = {
  error:null,
  log:null,
  loading:false,
  notificationsList:null,
  updatedStatus:false,
  globalNotifCount:0
};

export const notificationReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getNotificationList.pending, (state, action) => {
      state.loading = true
    })
    .addCase(getNotificationList.fulfilled, (state, action) => {
      state.notificationsList = action.payload.data;
      state.loading = false
      state.updatedStatus = false;
      state.globalNotifCount = action.payload.count;
    })
    .addCase(getNotificationList.rejected, (state, action) => {
      state.loading = false
      state.error = true
      state.log = action.payload
    })
    .addCase(createNotification.pending, (state, action) => {
      state.loading = true
    })
    .addCase(createNotification.fulfilled, (state, action) => {
      state.notificationsList = action.payload;
      state.loading = false
    })
    .addCase(createNotification.rejected, (state, action) => {
      state.loading = false
      state.error = true
      state.log = action.payload
    })
    .addCase(updateNotification.fulfilled, (state, action) => {
      const { id, status } = action.meta?.arg || {};
      if (id && state.notificationsList?.length) {
        const notificationIndex = state.notificationsList.findIndex(
          (notification) => notification.id === id
        );
        if (notificationIndex > -1) {
          const currentNotification = state.notificationsList[notificationIndex];
          const previousStatus = currentNotification?.status;

          if (status === 3) {
            state.notificationsList.splice(notificationIndex, 1);
          } else {
            state.notificationsList[notificationIndex] = {
              ...currentNotification,
              status,
            };
          }

          if (status === 3 && previousStatus === 1) {
            state.globalNotifCount = Math.max(
              0,
              (state.globalNotifCount || 0) - 1
            );
          } else if (status === 2 && previousStatus === 1) {
            state.globalNotifCount = Math.max(
              0,
              (state.globalNotifCount || 0) - 1
            );
          } else if (status === 1 && previousStatus === 2) {
            state.globalNotifCount = (state.globalNotifCount || 0) + 1;
          }
        }
      }

      state.updatedStatus = status === 3;
      state.loading = false
    })
    .addCase(updateNotification.rejected, (state, action) => {
      state.updatedStatus = false;
    })
    .addCase(setFcmToken.fulfilled, (state, action) => {
      state.updatedStatus = false;
      state.loading = false
    })
    .addCase(markAllRead.pending, (state, action) => {
      state.loading = true;
    })
    .addCase(markAllRead.fulfilled, (state, action) => {
      const { status } = action.meta?.arg || {};

      if (state.notificationsList?.length) {
        state.notificationsList = state.notificationsList.map((notification) => {
          if (status === 2) {
            return notification.status === 1
              ? { ...notification, status: 2 }
              : notification;
          }

          if (status === 1) {
            return notification.status === 2
              ? { ...notification, status: 1 }
              : notification;
          }

          return notification;
        });
      }

      if (status === 2) {
        state.globalNotifCount = 0;
      } else if (status === 1) {
        state.globalNotifCount = state.notificationsList?.length || 0;
      }

      state.updatedStatus = false;
      state.loading = false
    })
    .addCase(setGlobalNotificationCount.fulfilled, (state, action) => {
      state.globalNotifCount = 0;
    })
    .addCase(clearNotificationList, (state) => {
      state.notificationsList = initialState.notificationsList;
    });
});

